/* eslint-disable @typescript-eslint/no-unsafe-member-access */
/* eslint-disable @typescript-eslint/no-unsafe-assignment */
import { AxiosError } from 'axios';

import { APIService } from '@/src/infrastructure/Protocol/APIService';

import { IApiManagerService, IEmblueApiMethodNameMap } from './IApiManagerService';

import {
  IApiManagerCreateResponse,
  IApiManagerResponse,
} from '@/modules/ApiManagerModule/interfaces/apiManager';

/* eslint-disable @typescript-eslint/no-explicit-any */
export class ApiManagerService implements IApiManagerService {
  private api: APIService;

  private constructor(api: APIService) {
    this.api = api;
  }

  /**
   * @desc Catch errors from API
   */
  private catchErrors(error: AxiosError<Error>, method: string): void {
    const { message } = error;
    console.error(`❌ EM_Error ApiManagerService[${method}]:`, message);
  }

  /**
   * @param api APIService
   * @returns {IApiManagerService}
   * @description Create new instance of CampaignsService
   */
  static create(api: APIService): IApiManagerService {
    return new ApiManagerService(api);
  }

  /**
   * @desc Get all flows of a user
   * @returns {Promise<IApiManagerResponse>}
   */
  async getApiTokens(): Promise<IApiManagerResponse> {
    try {
      const { data } = await this.api.get<IApiManagerResponse>(`auth/keys`);
      return data;
    } catch (error) {
      this.catchErrors(error as AxiosError<Error>, 'getApiTokens');
      return { tokens: [], limit: 10 };
    }
  }

  /**
   * @desc Generate a new API key for a client
   * @param {string} name
   * @returns {Promise<boolean>}
   */
  async creteApiTokens(name: string): Promise<boolean> {
    try {
      const { status } = await this.api.post<IApiManagerCreateResponse>(`auth/keys`, { name });

      if (status !== 200) throw new Error('Error creating token');

      return true;
    } catch (error) {
      this.catchErrors(error as AxiosError<Error>, 'creteApiTokens');
      return false;
    }
  }
}

export const ApiManagerServiceMethods: IEmblueApiMethodNameMap = Object.getOwnPropertyNames(
  ApiManagerService.prototype
).reduce((h: any, k: any) => {
  h[k] = k;
  return h;
}, {} as typeof ApiManagerService);
